export { Spotlight } from './spotlight.component';
